<nz-form-explain *ngIf="_text || _errors">
  <ng-container *ngIf="_templateRef && _errors; else default">
    <ng-container *ngTemplateOutlet="_templateRef; context: {errors: _errors}"></ng-container>
  </ng-container>
  <ng-template #default>
    {{_text}}
  </ng-template>
</nz-form-explain>
